import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'

import { pageData } from 'decorators'
import { RaceSimulation } from 'components'
import PHASE from 'utils/constants/phases'
import './Race.css'
import { RaceTabResults } from './RaceTabResults'
import { RaceTabDetail } from './RaceTabDetail'
import { RaceTabCumulative } from './RaceTabCumulative'
import { RaceTabCurves } from './RaceTabCurves'
import { RaceTabFastLaps } from './RaceTabFastLaps'
import { Phase } from '../Phase'

@pageData({ title: 'Race' })
@connect(state => ({
    uuid: state.auth.uuid,
    phaseInfo: state.phaseInfo
}))
@translate()
export class Race extends PureComponent {
    static propTypes = {}

    state = {
        activeTab: 0,
        showSimulation: true,
        simulationStarted: false,
        hidingSimulation: false,
        showEndPhaseBtn: false
    }

    componentWillMount() {
        const { phaseInfo } = this.props
        this.showCumulativeRankingTab = phaseInfo.race > 1 && ((phaseInfo.data.players[0].cumulative || {}).speeds || []).length > 1
    }
    componentDidMount() {
        this.startAnimTimeout = setTimeout(this.startAnimation, RaceSimulation.SIMULATION_ANIM_DELAY)
    }

    componentWillUnmount() {
        this.startAnimTimeout && clearTimeout(this.startAnimTimeout)
        this.clearTimeouts()
    }
    clearTimeouts = () => {
        this.animTimeout && clearTimeout(this.animTimeout)
        this.hideAnimTimout && clearTimeout(this.hideAnimTimout)
    }

    startAnimation = () => {
        this.clearTimeouts()
        this.setState({ simulationStarted: true })
        this.animTimeout = setTimeout(this.startHidingSimulation, RaceSimulation.SIMULATION_ANIM_DURATION + 2000)
    }
    startHidingSimulation = () => {
        this.clearTimeouts()
        this.setState({ showSimulation: false, hidingSimulation: true, showEndPhaseBtn: true })
        this.hideAnimTimout = setTimeout(this.finishHidingSimulation, RaceSimulation.SIMULATION_HIDE_TRANSITION_ANIM_DURATION)
    }
    finishHidingSimulation = () => {
        this.clearTimeouts()
        this.setState({ showSimulation: false, hidingSimulation: false, showEndPhaseBtn: true })
    }

    renderNavItem = (link, index) => (
        <NavItem>
            <NavLink className={this.state.activeTab === index ? 'active' : ''} onClick={() => this.setState({ activeTab: index })}>
                {link}
            </NavLink>
        </NavItem>
    )
    render() {
        const {
            phaseInfo: { phase, data },
            t
        } = this.props
        const { activeTab, showSimulation, simulationStarted, hidingSimulation, showEndPhaseBtn } = this.state
        const numPlayers = ((data || {}).players || []).length
        return (
            phase === PHASE.RACE && (
                <Phase
                    className={['Race', { ShowSimulation: showSimulation, Started: simulationStarted, HidingSimulation: hidingSimulation }]}
                    showEndPhaseBtn={showEndPhaseBtn}
                    showFinishButton
                >
                    <section className="Content" onClick={showSimulation || hidingSimulation ? this.startHidingSimulation : null}>
                        <Nav tabs>
                            {this.renderNavItem(t('game.RACE.nav.raceResults'), 0)}
                            {this.renderNavItem(t('game.RACE.nav.seeDetails'), 1)}
                            {this.showCumulativeRankingTab && this.renderNavItem(t('game.RACE.nav.cumulative'), 2)}
                            {this.renderNavItem(t('game.RACE.nav.seeFastLaps'), 3)}
                            {numPlayers > 1 && this.renderNavItem(t('game.RACE.nav.seeCurves'), 4)}
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId={0}>
                                <RaceTabResults data={data} />
                            </TabPane>
                            <TabPane tabId={1} className="Scrollable">
                                <RaceTabDetail data={data} />
                            </TabPane>
                            {this.showCumulativeRankingTab && (
                                <TabPane tabId={2}>
                                    <RaceTabCumulative data={data} />
                                </TabPane>
                            )}
                            <TabPane tabId={3} className="Scrollable">
                                <RaceTabFastLaps data={data} />
                            </TabPane>
                            {numPlayers > 1 && (
                                <TabPane tabId={4} className="Scrollable">
                                    <RaceTabCurves data={data} />
                                </TabPane>
                            )}
                        </TabContent>
                    </section>
                </Phase>
            )
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Phases/Race/Race.js